import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-cyan-500/20 relative overflow-hidden">
      {/* Background Effect */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 py-12 relative z-10">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="text-2xl font-bold">
              <span className="text-cyan-400 neon-text">EFAM</span>
            </div>
            <p className="text-gray-400 max-w-xs text-sm">
              High-performance EMS technology designed to build strength, shape your body, and keep you moving forward
            </p>
            <div className="flex flex-col space-y-2">
              <a
                href={`mailto:${contactInfo.email}`}
                className="flex items-center space-x-2 text-gray-400 hover:text-cyan-400 transition-colors"
              >
                <Mail size={16} />
                <span className="text-sm">{contactInfo.email}</span>
              </a>
              <a
                href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                className="flex items-center space-x-2 text-gray-400 hover:text-cyan-400 transition-colors"
              >
                <Phone size={16} />
                <span className="text-sm">{contactInfo.phone} ({contactInfo.phoneHours})</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <div className="flex flex-col space-y-2">
              <a
                href="#packages"
                onClick={(e) => scrollToSection(e, '#packages')}
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              >
                Products
              </a>
              <a
                href="#accessories"
                onClick={(e) => scrollToSection(e, '#accessories')}
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              >
                Accessories
              </a>
              <a
                href="#faq"
                onClick={(e) => scrollToSection(e, '#faq')}
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              >
                FAQ
              </a>
              <a
                href="#contact"
                onClick={(e) => scrollToSection(e, '#contact')}
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              >
                Contact
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <div className="flex flex-col space-y-2">
              <Link
                to="/terms-of-service"
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              >
                Terms of Service
              </Link>
              <Link
                to="/privacy-policy"
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/refund-policy"
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              >
                Refund & Returns
              </Link>
              <Link
                to="/safety-information"
                className="text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              >
                Safety Information
              </Link>
            </div>
          </div>

          {/* Shipping Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Shipping</h3>
            <div className="space-y-2 text-sm text-gray-400">
              <p><span className="text-cyan-400">Express Worldwide:</span> 2-4 weeks</p>
              <p className="text-gray-500 mt-4">
                Included in every price — no extra fee, no slower option
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} EFAM All rights reserved
            </p>
            <p className="text-gray-600 text-xs">
              Forged for purpose Built from pressure
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
